export const listKahalemoiNoticesNotices = /* GraphQL */ `
  query ListKahalemoiNoticesNotices {
    listNotices(
      filter: { clientId: { eq: "3987d779-7e53-4de5-9f59-30561e9ed3e4" } }
    ) {
      nextToken
      items {
        groupId
        pdfSource
        title
        id
        imgSource
      }
    }
  }
`;
